module.exports = __webpack_public_path__ + "assets/img/7.19736eb8.png";